import { render } from "./CustomLink.vue?vue&type=template&id=3b056c2b&scoped=true"
import script from "./CustomLink.vue?vue&type=script&lang=js"
export * from "./CustomLink.vue?vue&type=script&lang=js"

import "./CustomLink.vue?vue&type=style&index=0&id=3b056c2b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b056c2b"]])

export default __exports__